import { useSwrNoAuth } from "../swr/useSwrNoAuth";

export const useFetchSoCouponUsageStatus = (lineAccountId: string) => {
  const { data: soCouponUsageStatus, error, isLoading } = useSwrNoAuth<string>(`socoupon/line-accounts/${lineAccountId}/socoupon-usage-status/`)
  return { soCouponUsageStatus, isLoading, error };
};